import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import authService from '../services/integratedAuthService';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);

  useEffect(() => {
    const checkAuthentication = async () => {
      // First check if we have token and user data
      if (!authService.isAuthenticated()) {
        setIsAuthenticated(false);
        return;
      }

      // Verify token
      const isValid = authService.verifyToken();
      setIsAuthenticated(isValid);
    };

    checkAuthentication();
  }, []);

  // Still checking authentication
  if (isAuthenticated === null) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        fontSize: '18px' 
      }}>
        Verifying authentication...
      </div>
    );
  }

  // Not authenticated, redirect to login
  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  // Authenticated, render children
  return <>{children}</>;
};

export default ProtectedRoute;
